import { Navigate } from "react-router-dom";

// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import AdminSignIn from "layouts/authentication/admin/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ResetPassword from "layouts/authentication/reset-password";
import ResetNewPassword from "layouts/authentication/confirmResetPassword";
import PrivateRoute from "layouts/authentication/PrivateRoute";

// Soft UI Dashboard React icons
import Shop from "reusableComponents/Icons/Shop";
import Office from "reusableComponents/Icons/Office";
import Document from "reusableComponents/Icons/Document";
import SpaceShip from "reusableComponents/Icons/SpaceShip";
import CustomerSupport from "reusableComponents/Icons/CustomerSupport";
import publications from "./layouts/publications";
import confirmation from "./layouts/authentication/confirmation";
import AgentDigitizations from "layouts/agent-publications";
import PaymentList from "./mainComponents/payment/PaymentList";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import FreeAgents from "./mainComponents/freeAgents/FreeAgents";
import DigitizationEditor from "./mainComponents/yai4eduEditor/DigitizationEditor";
import ErrorPages from "./reusableComponents/ErrorPages/ErrorPages";
import { MdMiscellaneousServices } from "react-icons/md";
import ServicesList from "./layouts/services/ServicesList";
import TranslationComponent from "layouts/translation-component";
import FeedbackList from "./reusableComponents/Feedback/FeedbackList";
import { VscFeedback } from "react-icons/vsc";
import {FREE_AGENT, SUPER_ADMIN_ROLE} from "./utlis/constant";
import {FaLanguage} from "react-icons/fa";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/:lang/dashboard",
    icon: <Shop size="12px" />,
    component: (
        <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE, FREE_AGENT]} component={Dashboard} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Free-agents List",
    key: "free-agents",
    route: "/:lang/free-agents",
    icon: <Office size="12px" />,
    component: (
        <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE]} component={FreeAgents} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Agent Digitizations",
    key: "agent-digitizations",
    route: "/:lang/agent-digitizations",
    icon: <Office size="12px" />,
    component: (
        <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE]} component={AgentDigitizations} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/:lang/profile",
    icon: <CustomerSupport size="12px" />,
    component: (
        <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE, FREE_AGENT]} component={Profile} />
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/:lang/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <PrivateRoute publicRoute={true} component={SignIn} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/:lang/admin/authentication/sign-in",
    icon: <Document size="12px" />,
    component: <PrivateRoute publicRoute={true} component={AdminSignIn} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    route: "/:lang/authentication/sign-up",
    icon: <SpaceShip size="12px" />,
    component: <PrivateRoute publicRoute={true} component={SignUp} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Reset Password Form",
    key: "reset-password-form",
    route: "/:lang/authentication/reset-password",
    icon: <SpaceShip size="12px" />,
    component: <PrivateRoute publicRoute={true} component={ResetPassword} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Confirm Reset Password",
    key: "confirm-reset-password",
    route: "/:lang/authentication/confirm-reset-password/:token",
    icon: <SpaceShip size="12px" />,
    component: <PrivateRoute publicRoute={true} component={ResetNewPassword} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Documents",
    key: "documents",
    route: "/:lang/documents",
    component: <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE, FREE_AGENT]} component={publications} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Confirmation",
    key: "confirmation",
    route: "/:lang/authentication/confirmation",
    component: <PrivateRoute publicRoute={true} component={confirmation} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Document",
    key: "document",
    route: "/:lang/document",
    icon: <Document size="12px" />,
    component: <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE, FREE_AGENT]} component={DigitizationEditor} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Payment list",
    key: "payment-list",
    route: "/:lang/payment-list",
    icon: <FaFileInvoiceDollar size="12px"/>,
    component: <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE]} component={PaymentList} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Invoices",
    key: "invoices",
    route: "/:lang/invoices",
    icon: <FaFileInvoiceDollar size="12px"/>,
    component: <PrivateRoute allowedRoles={[FREE_AGENT]} component={PaymentList} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Error",
    key: "error",
    route: "/error-page",
    icon: <FaFileInvoiceDollar size="12px"/>,
    component: <PrivateRoute publicRoute={true} component={ErrorPages} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Services List",
    key: "services-list",
    route: "/:lang/services-list",
    icon: <MdMiscellaneousServices size="12px"/>,
    component: <PrivateRoute publicRoute={true} component={ServicesList} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage feedback List",
    key: "feedback-list",
    route: "/:lang/feedback-list",
    icon: <VscFeedback size="12px"/>,
    component: <PrivateRoute allowedRoles={[SUPER_ADMIN_ROLE]} component={FeedbackList} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Fast Translation",
    key: "translation-service",
    route: "/:lang/translation-service",
    icon: <FaLanguage size="12px"/>,
    component: <PrivateRoute publicRoute={true} component={TranslationComponent} />,
    noCollapse: true,
  },
];

export default routes;
